module.exports = __webpack_public_path__ + "static/ULC Rollen-972e20eda364b016f4c96483423de152.jpg";